import { render, staticRenderFns } from "./widgetDevTrafficStatus.vue?vue&type=template&id=337bbd57&scoped=true&"
import script from "./widgetDevTrafficStatus.vue?vue&type=script&lang=js&"
export * from "./widgetDevTrafficStatus.vue?vue&type=script&lang=js&"
import style0 from "./widgetDevTrafficStatus.vue?vue&type=style&index=0&id=337bbd57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337bbd57",
  null
  
)

export default component.exports